/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import {
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
  MenuItemOption,
  MenuDivider
} from '@chakra-ui/react'
import { FaSort } from 'react-icons/fa'
import Styles from './styles.module.sass'

const DefaultSortItemsMenu = ({
  sortOptions,
  onChange,
  sortValue,
  sortOrder
}) => {
  const OrderIsDisabled = !sortValue
  const currentLabel = sortValue
    ? sortOptions.find(option => option.id === sortValue)
    : undefined
  const [currentOption, setCurrentOption] = useState(
    currentLabel ? currentLabel.label : undefined
  )
  const currentOnChange = ({ value, label }) => {
    setCurrentOption(label)
    onChange && onChange(value)
  }
  const onChangeSortOrder = (order) => {
    onChange && onChange(null, order)
  }
  const menuItems = sortOptions.map(option => {
    return (
      <MenuItemOption
        className="text-sm"
        value={option.id}
        key={option.id}
        onClick={() =>
          currentOnChange({
            value: option.id,
            label: option.label
          })
        }
      >
        {option.label}
      </MenuItemOption>
    )
  })

  return (
    <Menu
      onChange={currentOnChange}
    >
      <MenuButton
        transition='all 0.2s'
        borderRadius='md'
        borderWidth='1px'
        className={` ${Styles.menuButton} !text-sm`}
        _hover={{ bg: 'transparent' }}
        _expanded={{ bg: 'transparent' }}
        _focus={{ boxShadow: 'outline' }}
      >
        <FaSort className="inline-block" />
        <span>
          Sort by
        </span>
         {currentOption ? `: ${currentOption}` : ''}
      </MenuButton>
      <MenuList>
        <MenuOptionGroup
          title="Order By"
          type="checkbox"
          defaultValue={sortValue}
        >
          { menuItems }
        </MenuOptionGroup>
        <MenuDivider />
        <MenuOptionGroup
          defaultValue={sortOrder}
          title="Order"
          type="radio"
        >
          <MenuItemOption
            value="asc"
            className="text-sm"
            onClick={ () => onChangeSortOrder('asc') }
            isDisabled={OrderIsDisabled}
          >
            Ascending
          </MenuItemOption>
          <MenuItemOption
            value="desc"
            className="text-sm"
            onClick={ () => onChangeSortOrder('desc') }
            isDisabled={OrderIsDisabled}
          >
            Descending
          </MenuItemOption>
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  )
}

export default DefaultSortItemsMenu
